import React, { useEffect, useRef } from "react";
import * as speechSdk from "microsoft-cognitiveservices-speech-sdk";
import Layout from "../components/Layout/Layout";
import { InputCustom } from "../components/Forms/CustomInput/CustomInput";
import CustomIcon from "../components/Icons/CustomIcon";
import { GenerateImageContext } from "../context/GenerateImageContext";
import { BiChevronRight } from "react-icons/bi";
import GPimage from "../images/gpInteligence.svg";
import cameraImg from "../images/camera.png";
import ProgressBar from "../components/ProgressBar/ProgressBar";
import config from "../config/config";
import { Button, Spinner, Text } from "@fluentui/react-components";
import "./ImageGenerator.css";
import "react-multi-carousel/lib/styles.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../components/Layout/Layout.css";
import ReactGA4 from "react-ga4";
import {Dialog,DialogSurface,DialogTitle,DialogContent,DialogTrigger,DialogBody} from "@fluentui/react-components";


const ImageGenerator = () => {
  const {
    generatedImages,
    loading,
    saveImage,
    saveLoading,
    errorMessage,
    generateImageUrl,
    generateImage,
    progress,
    resetProgressContext,
  } = React.useContext(GenerateImageContext);
  const [prompt, setPrompt] = React.useState(
    "Modern variants, blue sky, golden hour, soft light, incorporate the image as part of the building, Make the image as realistic as possible.Builing surrounded natural landscape and some other buildings. Be sure to create interesting and cozy spaces. The colors should be warm and earthy, with a rustic yet modern feel."
  );
  const speechConfig = useRef(null);
  const audioConfig = useRef(null);
  const speechRecognizer = useRef(null);
  const fileInputRef = useRef();
  const [file, setFile] = React.useState(null);
  const windowWidth = useRef(window.innerWidth);
  const [open, setOpen] = React.useState(false);
  useEffect(() => {
    speechConfig.current = speechSdk.SpeechConfig.fromSubscription(
      config.speech.key,
      config.speech.region
    );
    speechConfig.current.speechRecognitionLanguage = "es-UY";
    audioConfig.current = speechSdk.AudioConfig.fromDefaultMicrophoneInput();
    speechRecognizer.current = new speechSdk.SpeechRecognizer(
      speechConfig.current,
      audioConfig.current
    );
    const processRecognizedTranscript = (event) => {
      const result = event.result;
      if (result.reason === speechSdk.ResultReason.RecognizedSpeech) {
        const transcript = result.text;
        if (result.text.length > 0) {
          setPrompt(transcript);
        }
      }
    };

    speechRecognizer.current.recognized = (s, e) =>
      processRecognizedTranscript(e);

    return () => {
      speechRecognizer.current.stopContinuousRecognitionAsync(() => {});
    };
  }, []);

  const sendGoogleAnalytics = () => {
    const date = new Date();
    ReactGA4.event({
      category: "request_image_GP",
      action: "image_GP",
      label:`request image user search ${date.toString()}`,
    });
  }

  const handleChangeImag = (event) => {
    setFile(event.target.files[0]);
  };

  const uploadImageAndText = async () => {
    sendGoogleAnalytics();
    resetProgressContext();
    if (!file) {
      // Mostrar el Popover si no hay ninguna imagen seleccionada
      setOpen(true);
      return;
    }
    if (file) {
      const data = await generateImageUrl(file);
      await generateImage({ prompt: prompt, imageUri: data.url });
      setFile(null);
    }
  };
  const handleKeysendPrompt = (e) => {
    if (e.key === "Enter") {
      uploadImageAndText();
    }
  };

  return (
    <>
      <Layout>
        <div
          className="image-generate"
          style={
            generatedImages.length === 0 && windowWidth.current <= 658
              ? { position: "fixed", width: "100%" }
              : null
          }
        >
          {generatedImages.length === 0 || progress <= 99 ? (
            <>
              <img src={GPimage} alt="gp" className="gpImg" />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "fixed",
                  marginTop: "440px",
                }}
              >
                {!loading ? (
                  <>
                    <button
                      className="button-sign"
                      disabled={prompt.length === 0 || loading}
                      onClick={
                        !file
                          ? () => {
                              fileInputRef.current.click();
                            }
                          : () => uploadImageAndText()
                      }
                    >
                      {!file ? (
                        <>
                          <span>Carga tu foto</span>{" "}
                          <img src={cameraImg} alt="img" className="imgcamera"/>
                        </>
                      ) : (
                        <>
                          <span>Siguiente</span>{" "}
                          <BiChevronRight style={{ fontSize: "20px" }} />
                        </>
                      )}
                    </button>
                    <div className="filename">{file?.name}</div>
                    <Dialog
                      open={open}
                      onOpenChange={(event, data) => {
                        setOpen(data.open);
                      }}
                      style={{ width: "80%" }}
                    >
                      <DialogSurface
                        aria-describedby={undefined}
                        className="dialog-container"
                        style={{
                          backgroundColor: "rgba(0,0,0,0.8)",
                          maxWidth: "100%",
                          marginTop: "55px",
                          width: "95%",
                          height: "100%",
                          textAlign: "center",
                        }}
                      >
                        <DialogBody>
                          <DialogTitle
                            action={
                              <DialogTrigger action="close">
                                <Button
                                  appearance="subtle"
                                  aria-label="Cerrar"
                                  icon={<CustomIcon type="close" />}
                                />
                              </DialogTrigger>
                            }
                          ></DialogTitle>
                          <DialogContent>
                            <div
                              style={{
                                display: "grid",
                                overflow: "hidden",
                                gridTemplateRows: "auto auto 60px",
                              }}
                            >
                              <span>
                                Porfavor, debe cargar una imagen primero
                              </span>
                            </div>
                          </DialogContent>
                        </DialogBody>
                      </DialogSurface>
                    </Dialog>
                  </>
                ) : null}

                <input
                  type="file"
                  accept="image/*"
                  onChange={handleChangeImag}
                  multiple={false}
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  id="upload"
                  hidden
                />
              </div>

              <InputCustom
                size="medium"
                value={prompt}
                disabled={loading}
                onChange={(event) => setPrompt(event.target.value)}
                onKeyDown={(e) => handleKeysendPrompt(e)}
                className="prompt-harc"
              />
            </>
          ) : null}

          {loading && progress <= 99 && generatedImages.length === 0 && (
            <ProgressBar value={progress} />
          )}
          {generatedImages.length === 0 &&
          progress === 100 &&
          (errorMessage === "" || !errorMessage) ? (
            <div className="HomeBanner"></div>
          ) : (
            <div style={{ marginBottom: "50px" }}>
              <Text align="justify">{errorMessage}</Text>
            </div>
          )}
          {!loading && progress === 100 && generatedImages.length > 0 && (
            <div className="boxing-generete">
              {generatedImages.map((image, index) => (
                <div key={index} className="contain-carrousel">
                  <div
                    style={{
                      position: "absolute",
                      bottom: "2%",
                      right: "4%",
                    }}
                  >
                    {image.saved ? (
                      <CustomIcon
                        type="check"
                        filled={true}
                        style={{
                          height: "20px",
                          marginRight: "20px",
                          marginTop: "8px",
                        }}
                        size="tiny"
                      />
                    ) : saveLoading ? (
                      <Spinner
                        style={{
                          height: "20px",
                          marginRight: "20px",
                          marginTop: "8px",
                        }}
                        size="tiny"
                      />
                    ) : (
                      <Button
                        appearance="subtle"
                        icon={<CustomIcon type="save" />}
                        size="small"
                        style={{ height: "35px" }}
                        onClick={() =>
                          saveImage({
                            prompt: image.prompt.prompt,
                            uri: image.uri,
                            operationId: image.operationId,
                          })
                        }
                      />
                    )}
                  </div>
                  <div
                    style={{
                      justifyContent: "end",
                      float: "right",
                      marginTop: "8px",
                      marginRight: "10px",
                    }}
                  ></div>
                  <img
                    alt={prompt}
                    src={image.uri}
                    style={{
                      width: "300px",
                      height: "300px",
                      objectFit: "scale-down",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </Layout>
    </>
  );
};

export default ImageGenerator;
